import { Button, Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  TopToolbar,
  ExportButton,
  FilterButton,
} from 'react-admin';
import MainLayout from '../layout/MainLayout';
import { StatusField } from './StatusField';
import { billFilters } from './BillFilter';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import Color from '../layout/color/Color';
import FontSize from '../layout/FontSize';

// const saveButton = {
//   bgcolor: Color.Main,
//   borderRadius: '30px',
//   border: '1px solid Color.Main',
//   fontWeight: '500',
//   textAlign: 'center',
//   padding: '4px 8px',
//   color: Color.Button,
//   transition: '0.3s',
//   fontSize: FontSize.Medium,
//   textTransform: 'none',
//   '&:hover': { background: Color.Button, color: Color.Normal }
// };

const backButton = {
  bgcolor: Color.Button,
  borderRadius: '30px',
  border: "1px solid #055C2D",
  color: Color.Main,
  fontWeight: '500',
  textAlign: 'center',
  padding: '4px 8px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Main, color: Color.Button }
};

export const BillList = () => {

  return (
    <>
      <MainLayout>
        <Grid sx={{ textAlign: 'left' }}>
          <Button
            endIcon={<LocalAtmIcon sx={{ color: Color.Main }} />}
            sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
            size="medium"
          >
            <Typography variant="h3">Bill Management</Typography>
          </Button>
        </Grid>
        <Divider sx={{ width: '100%', mb: 2 }} />
        <List filters={billFilters} actions={<BillListActions />}>
          <Datagrid
            bulkActionButtons={false}
          >
            <TextField source="code" />
            <TextField source="name" />
            <TextField source="price" />
            <TextField source="discount" />
            <DateField source="created_at" />
            <StatusField source="status" />
            <TextField source="tran_account" />
            <TextField source="tran_amount" />
            <TextField source="tran_date" />
          </Datagrid>
        </List>
      </MainLayout>
    </>
  );
};

const BillListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <ExportButton sx={backButton} />
    </TopToolbar>
  );
};


